module.exports = __webpack_public_path__ + "static/media/regalo_send.3889d6e3.png";